import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

interface SearchInputProps {
  defaultValue?: string;
  placeholder?: string;
  size?: "sm" | "lg";
  className?: string;
}

export default function SearchInput({
  defaultValue = "",
  placeholder = "搜索片名、演员或标签",
  size = "sm",
  className = "",
}: SearchInputProps) {
  const navigate = useNavigate();
  const [value, setValue] = useState(defaultValue);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const q = value.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  const isLarge = size === "lg";

  return (
    <form onSubmit={handleSubmit} className={`relative flex items-center ${className}`} role="search">
      <i
        className={`ri-search-line pointer-events-none absolute left-3 text-foreground-400 ${
          isLarge ? "text-base" : "text-sm"
        }`}
        aria-hidden="true"
      />
      <input
        type="search"
        name="q"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        aria-label="搜索电影"
        className={`w-full rounded-md border border-background-300 bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-200 ${
          isLarge ? "py-3 pl-10 pr-24 text-sm" : "py-2 pl-9 pr-16 text-sm"
        }`}
      />
      <button
        type="submit"
        className={`absolute right-1 whitespace-nowrap rounded-md bg-primary-500 font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600 ${
          isLarge ? "px-5 py-2 text-sm" : "px-3 py-1.5 text-xs"
        }`}
      >
        搜索
      </button>
    </form>
  );
}